import { useRef, useState } from "react";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { Delete, Edit, MoreVert, Restore } from "@mui/icons-material";

// ----------------------------------------------------------------------

export default function MoreMenu({
  setOpenDeleteDialog,
  setOpenEditDialog,
  setOpenRestoreDialog,
  setRow,
  userRole,
  itemActions = ['Delete'],
  is_active,
  showRestore = false
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {userRole && userRole.includes("Delete") && !is_active && showRestore && (
        <Tooltip title="Restore" placement="top">
          <IconButton
            onClick={() => {
              setOpenRestoreDialog(true);
              setRow();
            }}
          >
            <Restore />
          </IconButton>
        </Tooltip>
      )}

      {userRole && userRole.includes("Delete") && is_active && (
        <Tooltip title="Delete" placement="top">
          <IconButton
            onClick={() => {
              setOpenDeleteDialog(true);
              setRow();
            }}
          >
            <Delete />
          </IconButton>
        </Tooltip>
      )}

      {userRole && userRole.includes("Edit") && (
        <Tooltip title="Edit" placement="top">
          <IconButton
            onClick={() => {
              setOpenEditDialog(true);
              setRow();
            }}
          >
            <Edit />
          </IconButton>
        </Tooltip>
      )}
    </>
  );

  // return (
  //   <>
  //     <IconButton ref={ref} onClick={() => setIsOpen(true)}>
  //       <MoreVert />
  //     </IconButton>

  //     <Menu
  //       open={isOpen}
  //       anchorEl={ref.current}
  //       onClose={() => setIsOpen(false)}
  //       PaperProps={{
  //         sx: { width: 200, maxWidth: "100%" },
  //       }}
  //       anchorOrigin={{ vertical: "top", horizontal: "right" }}
  //       transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     >
  //       {userRole && userRole.includes("Edit") && (
  //         <MenuItem
  //           onClick={() => {
  //             setOpenEditDialog(true);
  //             setRow();
  //           }}
  //           sx={{ color: "text.secondary" }}
  //         >
  //           <ListItemIcon>
  //             <Edit />
  //           </ListItemIcon>
  //           <ListItemText
  //             primary="Edit"
  //             primaryTypographyProps={{ variant: "body2" }}
  //           />
  //         </MenuItem>
  //       )}

  //       {userRole && userRole.includes("Delete") && is_active &&  (
  //         <MenuItem
  //           sx={{ color: "text.secondary" }}
  //           onClick={() => {
  //             setOpenDeleteDialog(true);
  //             setRow();
  //           }}
  //         >
  //           <ListItemIcon>
  //             <Delete />
  //           </ListItemIcon>
  //           <ListItemText
  //             primary="Delete"
  //             primaryTypographyProps={{ variant: "body2" }}
  //           />
  //         </MenuItem>
  //       )}

  //       {userRole && userRole.includes("Delete") && !is_active && showRestore && (
  //         <MenuItem
  //           sx={{ color: "text.secondary" }}
  //           onClick={() => {
  //             setOpenRestoreDialog(true);
  //             setRow();
  //           }}
  //         >
  //           <ListItemIcon>
  //             <Restore />
  //           </ListItemIcon>
  //           <ListItemText
  //             primary="Restore"
  //             primaryTypographyProps={{ variant: "body2" }}
  //           />
  //         </MenuItem>
  //       )}
  //     </Menu>
  //   </>
  // );
}
